import { cva as l, ct as o } from "@/styled-system/css";
const t = l({
  base: { transition: "200ms ease color" },
  variants: {
    tone: {
      brand: {},
      neutral: {},
      critical: {}
    },
    emphasis: {
      filled: {},
      outlined: {}
    },
    disabled: {
      true: {},
      false: {}
    },
    onImpact: {
      true: {},
      false: {}
    },
    loading: {
      true: {
        color: "transparent"
      },
      false: {}
    }
  },
  compoundVariants: [
    {
      emphasis: "filled",
      tone: "brand",
      loading: !1,
      css: {
        color: {
          base: o("Button.colors.filled.brand.label.default"),
          _notDisabled: {
            _groupHover: o("Button.colors.filled.brand.label.hover"),
            _groupActive: o("Button.colors.filled.brand.label.pressed")
          }
        }
      }
    },
    {
      emphasis: "filled",
      tone: "critical",
      loading: !1,
      css: {
        color: {
          base: o("Button.colors.filled.critical.label.default"),
          _notDisabled: {
            _groupHover: o("Button.colors.filled.critical.label.hover"),
            _groupActive: o("Button.colors.filled.critical.label.pressed")
          }
        }
      }
    },
    {
      emphasis: "outlined",
      tone: "brand",
      loading: !1,
      css: {
        color: {
          base: o("Button.colors.outlined.brand.label.default"),
          _notDisabled: {
            _groupHover: o("Button.colors.outlined.brand.label.hover"),
            _groupActive: o("Button.colors.outlined.brand.label.pressed")
          }
        }
      }
    },
    {
      emphasis: "outlined",
      tone: "neutral",
      loading: !1,
      css: {
        color: {
          base: o("Button.colors.outlined.neutral.label.default"),
          _notDisabled: {
            _groupHover: o("Button.colors.outlined.neutral.label.hover"),
            _groupActive: o("Button.colors.outlined.neutral.label.pressed")
          }
        }
      }
    },
    {
      onImpact: !0,
      emphasis: "filled",
      tone: "brand",
      loading: !1,
      css: {
        color: {
          base: o("Button.colors.onImpact.filled.brand.label.default"),
          _notDisabled: {
            _groupHover: o("Button.colors.onImpact.filled.brand.label.hover"),
            _groupActive: o("Button.colors.onImpact.filled.brand.label.pressed")
          }
        }
      }
    },
    {
      onImpact: !0,
      emphasis: "outlined",
      tone: "neutral",
      loading: !1,
      css: {
        color: {
          base: o("Button.colors.onImpact.outlined.neutral.label.default"),
          _notDisabled: {
            _groupHover: o("Button.colors.onImpact.outlined.neutral.label.hover"),
            _groupActive: o("Button.colors.onImpact.outlined.neutral.label.pressed")
          }
        }
      }
    }
  ]
});
export {
  t as buttonIconRecipe
};
//# sourceMappingURL=button-icon.styles.js.map
